import { render, staticRenderFns } from "./formCreateFeed.vue?vue&type=template&id=5f78b563&scoped=true&"
import script from "./formCreateFeed.vue?vue&type=script&lang=js&"
export * from "./formCreateFeed.vue?vue&type=script&lang=js&"
import style0 from "./formCreateFeed.vue?vue&type=style&index=0&id=5f78b563&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f78b563",
  null
  
)

export default component.exports